export const cstmdummyHFAC =
    [
        {
            "Id": 1,
            "Name": 'P&SHD',
        },
        {
            "Id": 2,
            "Name": 'PHFMC',
        },
        {
            "Id": 3,
            "Name": 'HPD',
        },
        {
            "Id": 4,
            "Name": 'SHD',
        },
        {
            "Id": 5,
            "Name": 'INDUS',
        }

    ]
export const cstmdummyHOD =
    [
        {
            "Id": 110839,
            "Name": 'Muhammad Ahmar Khan',
        },
    ]
export const cstmdummyGender =
    [
        "Male",
        "Female"
    ]
export const cstmdummyModes =
    [
        {
            "Id": 1,
            "Name": 'BHU 24/7',
        },
        {
            "Id": 2,
            "Name": 'Plus',
        },
        {
            "Id": 3,
            "Name": 'Other',
        }
    ]
export const cstmdummyOrderReasons =
    [
        {
            "Id": 1,
            "Name": 'on poor performance',
        },
        {
            "Id": 2,
            "Name": 'on administrative grounds',
        },
        {
            "Id": 3,
            "Name": 'on his/her own request',
        },
        {
            "Id": 4,
            "Name": 'public interest',
        },
        {
            "Id": 5,
            "Name": 'other',
        }
    ]
export const cstmdummyStatus =
    [
        {
            "Id": 1,
            "Name": 'Functional',
        },
        {
            "Id": 2,
            "Name": 'Non Functional',
        }
    ]

export const cstmdummyActiveStatus =
    [
        {
            "Id": 1,
            "Name": 'Active',
        },
        {
            "Id": 0,
            "Name": 'In Active',
        }
    ]

export const cstmdummyCadre =
    [
        {
            "Id": 1,
            "Name": 'General Cadre',
        },
        {
            "Id": 2,
            "Name": 'Allied Cadre',
        }
    ]
export const cstmdummyScale =
    [
        { text: 1, value: 1 },
        { text: 2, value: 2 },
        { text: 3, value: 3 },
        { text: 4, value: 4 },
        { text: 5, value: 5 },
        { text: 6, value: 6 },
        { text: 7, value: 7 },
        { text: 8, value: 8 },
        { text: 9, value: 9 },
        { text: 10, value: 10 },
        { text: 11, value: 11 },
        { text: 12, value: 12 },
        { text: 13, value: 13 },
        { text: 14, value: 14 },
        { text: 15, value: 15 },
        { text: 16, value: 16 },
        { text: 17, value: 17 },
        { text: 18, value: 18 },
        { text: 19, value: 19 },
        { text: 20, value: 20 },
        { text: 21, value: 21 }
    ]

export const genderItems: any[] = [
    { text: 'Select Gender', value: null },
    { text: 'Male', value: 'Male' },
    { text: 'Female', value: 'Female' }
]
export const maritalStatusItems: any[] = [
    {
        text: 'Single', value: 'Single'
    },
    {
        text: 'Married', value: 'Married'
    },
    {
        text: 'Widow', value: 'Widow'
    },
    {
        text: 'Widower', value: 'Widow'
    }
]
export const bloodGroupItems: any[] = [
    {
        text: 'O+ve', value: 'O+ve'
    },
    {
        text: 'O-ve', value: 'O-ve'
    },
    {
        text: 'A+ve', value: 'A+ve'
    },
    {
        text: 'A-ve', value: 'A-ve'
    },
    {
        text: 'B+ve', value: 'B+ve'
    },
    {
        text: 'B-ve', value: 'B-ve'
    },
    {
        text: 'AB+ve', value: 'AB+ve'
    },
    {
        text: 'AB-ve', value: 'AB-ve'
    }
]
export const hodItems: any[] = [
    { Id: '1', Name: 'Yes' },
    { Id: '2', Name: 'No' }
]
export const privatePractiveItems: any[] = [
    { text: 'Yes', value: 'Yes' },
    { text: 'No', value: 'No' }]


export const cstmdummyGazatted =
    [
        {
            "Id": 1,
            "Name": 'Gazatted',
        },
        {
            "Id": 2,
            "Name": 'Non Gazatted',
        }
    ]
export const cstmdummyReligion =
    [
        {
            "Id": 1,
            "Name": 'Muslim',
        },
        {
            "Id": 2,
            "Name": 'Non Muslim',
        }
    ]
export const cstmdummyLanguages =
    [
        {
            "Id": 1,
            "Name": 'Balochi',
        },
        {
            "Id": 2,
            "Name": 'Barhavi',
        }, {
            "Id": 3,
            "Name": 'English',
        }, {
            "Id": 4,
            "Name": 'Khetrani',
        }, {
            "Id": 5,
            "Name": 'Pashto',
        }, {
            "Id": 6,
            "Name": 'Punjabi',
        }, {
            "Id": 7,
            "Name": 'Sariki',
        }, {
            "Id": 8,
            "Name": 'Sindhi',
        }, {
            "Id": 9,
            "Name": 'Urdu',
        }
    ]
export const cstmdummyRetirementTypes =
    [
        {
            "Id": 1,
            "Name": '10 Years Retirement',
        },
        {
            "Id": 2,
            "Name": '25 Years Retirement',
        },
        {
            "Id": 3,
            "Name": 'Superanuation',
        }
    ]
export const cstmdummyOperatorId =
    [
        { "Id": 1, "Name": 'Is equal to', "Operator": "$in" },
        { "Id": 2, "Name": 'Is not equal to', "Operator": "$nin" },
    ]
export const cstmdummyOperatorString =
    [
        { "Id": 1, "Name": 'Is equal to', "Operator": "$in" },
        { "Id": 2, "Name": 'Is not equal to', "Operator": "$nin" },
        { "Id": 3, "Name": 'Contains', "Operator": "$or" },
        { "Id": 4, "Name": 'Does not contains', "Operator": "$nor" },
        { "Id": 5, "Name": 'Starts with', "Operator": "$or" },
        { "Id": 6, "Name": 'Ends with', "Operator": "$or" },
        { "Id": 7, "Name": 'Is null or empty', "Operator": "$in" },
        { "Id": 8, "Name": 'Is not null or empty', "Operator": "$nin" }
    ]
export const cstmdummyOperatorDropDown =
    [
        { "Id": 1, "Name": 'Is equal to', "Operator": "$in" },
        { "Id": 2, "Name": 'Is not equal to', "Operator": "$nin" },
        { "Id": 7, "Name": 'Is null', "Operator": "$in" },
        { "Id": 8, "Name": 'Is not null', "Operator": "$nin" },
    ]
export const cstmdummyOperatorNumber =

    [
        { "Id": 1, "Name": 'Is equal to', "Operator": "$in" },
        { "Id": 2, "Name": 'Is not equal to', "Operator": "$nin" },
        { "Id": 9, "Name": 'Is greater than' },
        { "Id": 10, "Name": 'Is greater than or equal to' },
        { "Id": 11, "Name": 'Is less than' },
        { "Id": 12, "Name": 'Is less than or equal to' },
        { "Id": 7, "Name": 'Is null', "Operator": "$in" },
        { "Id": 8, "Name": 'Is not null', "Operator": "$nin" },
    ]
export const cstmdummyOperatorDate =
    [
        { "Id": 1, "Name": 'Is equal to', "Operator": "$eq" },
        { "Id": 2, "Name": 'Is not equal to', "Operator": "$ne" },
        { "Id": 13, "Name": 'Is after', "Operator": "$gt" },
        { "Id": 14, "Name": 'Is after or equal to, "Operator": "$gte"' },
        { "Id": 15, "Name": 'Is before', "Operator": "$lt" },
        { "Id": 16, "Name": 'Is before or equal to', "Operator": "$lte" },
        { "Id": 7, "Name": 'Is null', "Operator": "$in" },
        { "Id": 8, "Name": 'Is not null', "Operator": "$nin" },
    ]
export const cstmdummyOperatorBoolean =

    [
        { "Id": 17, "Name": '(All)' },
        { "Id": 18, "Name": 'Is True', "Operator": "$eq" },
        { "Id": 19, "Name": 'Is False', "Operator": "$ne" },
    ]
export const cstmdummyOperators =

    [
        { "Id": 1, "Name": 'Is equal to', "Operator": "$in" },
        { "Id": 2, "Name": 'Is not equal to', "Operator": "$nin" },
        { "Id": 3, "Name": 'Contains', "Operator": "$or" },
        { "Id": 4, "Name": 'Does not contains', "Operator": "$nor" },
        { "Id": 5, "Name": 'Starts with', "Operator": "$or" },
        { "Id": 6, "Name": 'Ends with', "Operator": "$or" },
        { "Id": 7, "Name": 'Is null', "Operator": "$in" },
        { "Id": 8, "Name": 'Is not null', "Operator": "$nin" },
        { "Id": 9, "Name": 'Is greater than' },
        { "Id": 10, "Name": 'Is greater than or equal to' },
        { "Id": 11, "Name": 'Is less than' },
        { "Id": 12, "Name": 'Is less than or equal to' },
        { "Id": 13, "Name": 'Is after' },
        { "Id": 14, "Name": 'Is after or equal to' },
        { "Id": 15, "Name": 'Is before' },
        { "Id": 16, "Name": 'Is before or equal to' },
        { "Id": 17, "Name": '(All)' },
        { "Id": 18, "Name": 'Is True' },
        { "Id": 19, "Name": 'Is False' }
    ]
export const cstmdummyDbTables =
    [
        {
            "Id": 1,
            "Name": 'Health Facility Types',
        },
        {
            "Id": 2,
            "Name": 'Designations',
        },
        {
            "Id": 3,
            "Name": 'Services',
        },
        {
            "Id": 4,
            "Name": 'Officers',
        },
        {
            "Id": 5,
            "Name": 'Cadres',
        },
        {
            "Id": 6,
            "Name": 'Order Types',
        },
        {
            "Id": 7,
            "Name": 'Transfer Types',
        },
        {
            "Id": 8,
            "Name": 'Leave Types',
        }
    ]

export const cstmdummyUserLevels =
    [
        {
            "Id": 1,
            "Name": 'Division',
        },
        {
            "Id": 2,
            "Name": 'District',
        },
        {
            "Id": 3,
            "Name": 'Tehsil',
        },
        {
            "Id": 4,
            "Name": 'Health Facility Type',
        },
        {
            "Id": 5,
            "Name": 'Health Facility',
        }
    ]

export class Product {
    public ProductID: number;
    public ProductName = '';
    public Discontinued = false;
    public UnitsInStock: number;
    public UnitPrice = 0;
}

export const cstmdummyDesignations =
    [
        {
            "Id": 1,
            "Name": 'Medical Officer',
        },
        {
            "Id": 2,
            "Name": 'Women Medical Officer',
        },
        {
            "Id": 3,
            "Name": 'Services',
        },
        {
            "Id": 4,
            "Name": 'Officers',
        },
        {
            "Id": 5,
            "Name": 'Cadres',
        },
        {
            "Id": 6,
            "Name": 'Transfer Types',
        },
        {
            "Id": 7,
            "Name": 'Leave Types',
        }
    ]